<a href="{{ad?.link}}" target="blank">
  <div class="media" [ngStyle]="{'background-image': 'url(' + ad?.better_featured_image?.media_details?.sizes['fusion-400']?.source_url + ')', 'height.px': ad?.better_featured_image?.media_details?.sizes['fusion-400']?.height }">
  </div>
  <h4 [innerHTML]="ad?.title?.rendered | safeHtml"></h4>
  <div class="excerpt" [innerHTML]="ad?.excerpt?.rendered | safeHtml"></div>
  <span class="link" translate="ad.more"></span>
</a>
